import { colors, alphaVar } from "./colors";

/** Same shell as Email Recipients & Notes: soft gray border, very light shadow (no heavy elevation). */
export const invoiceEditorSectionCardSx = {
  borderRadius: 2,
  border: "none",
  boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
  overflow: "hidden",
  bgcolor: "background.paper",
} as const;

/** Section dividers inside those blocks (matches EmailRecipientsList header rows). */
export const invoiceEditorInnerBorder = `1px solid ${alphaVar(colors.gray[200], 0.3)}`;
